import { Mail, Phone, MapPin, Linkedin, Github, MessageCircle } from "lucide-react";
import { OWNER } from "@/data/portfolio";

export default function Footer() {
  const year = new Date().getFullYear();
  const whatsappUrl = `https://wa.me/${OWNER.whatsapp}`;
  return (
    <footer className="relative border-t border-white/5 bg-black/30 backdrop-blur-sm" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-xl bg-[#FF3B30] text-white grid place-items-center font-display font-black text-lg">S</span>
              <span className="font-display font-bold text-xl">Sunil<span className="text-[#FF3B30]">.</span></span>
            </div>
            <p className="text-sm text-white/60 max-w-sm leading-relaxed">
              Website Designer & Frontend Developer building fast, responsive, and SEO-friendly websites for growing businesses.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Quick Links</p>
            <ul className="space-y-2">
              {['about','services','portfolio','skills','contact'].map(id => (
                <li key={id}>
                  <a href={`#${id}`} className="text-sm text-white/70 hover:text-[#FF3B30] transition-colors capitalize">{id}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Get in touch</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#FF3B30]" /> {OWNER.email}</li>
              <li className="flex items-center gap-2"><Phone size={14} className="text-[#FF3B30]" /> {OWNER.phoneDisplay}</li>
              <li className="flex items-start gap-2"><MapPin size={14} className="text-[#FF3B30] mt-0.5" /> <span>{OWNER.location}</span></li>
            </ul>

            <div className="flex items-center gap-3 mt-5">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-9 h-9 grid place-items-center rounded-lg bg-white/5 border border-white/10 hover:border-[#FF3B30]/40 hover:bg-[#FF3B30]/10 transition-colors">
                <MessageCircle size={14} />
              </a>
              <a href={OWNER.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 grid place-items-center rounded-lg bg-white/5 border border-white/10 hover:border-[#FF3B30]/40 hover:bg-[#FF3B30]/10 transition-colors">
                <Linkedin size={14} />
              </a>
              <a href={OWNER.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="w-9 h-9 grid place-items-center rounded-lg bg-white/5 border border-white/10 hover:border-[#FF3B30]/40 hover:bg-[#FF3B30]/10 transition-colors">
                <Github size={14} />
              </a>
            </div>
          </div>
        </div>

        <div className="divider-line mt-12 mb-6" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {year} Sunil KP. All rights reserved.</p>
          <p>Crafted with care in Chikmagalur · Karnataka</p>
        </div>
      </div>
    </footer>
  );
}
